import { create } from "zustand";
import { BudgetSummary } from "@/lib/types";
import { devtools } from "zustand/middleware";

type BudgetsStore = {
  currentBudget: BudgetSummary | null;
  setCurrentBudget: (budget: BudgetSummary) => void;
};

const useBudgets = create<BudgetsStore>()(
  devtools(
    (set) => ({
      currentBudget: null,
      setCurrentBudget: (budget: BudgetSummary) =>
        set({ currentBudget: budget }),
    }),
    { name: "budgets" }
  )
);

export default useBudgets;
